export default function({ from, route, store }) {
  const fromName = (from && from.name) || null
  const toName = route.name
  const toFullPath = route.fullPath
  const isFirstLoad = process.server

  store.dispatch('setRouterNavigationDetails', {
    toName,
    toFullPath,
    fromName,
    isFirstLoad
  })
}
